import React, { Component } from "react"
import "./InsCGUBar.scss"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"

class InsCGUBar extends Component {
  render() {
    const { t, config, location } = this.props
    const { opt_ins } = config.register
    const path = location.pathname
    return (
      <div
        className={path === '/' ? `cgu_container container-width is-fixed` : `cgu_container container-width`}
        style={{ marginTop: "auto" }}>
        <div className="cgu_bar">
            {path.includes('/wall') && opt_ins["ctFilePath"] ?
              (
                <a
                  className="cgu_link"
                  href={opt_ins ? opt_ins["ctFilePath"] : null}
                  target="_blank"
                  rel="noopener noreferrer">
                  <p>{t("community_terms")}</p>
                </a>
              ) : path.includes('/shop') && opt_ins["tousFilePath"] ?
                (
                  <a
                    className="cgu_link"
                    href={opt_ins ? opt_ins["tousFilePath"] : null}
                    target="_blank"
                    rel="noopener noreferrer">
                    <p>{t("terms_of_use")}</p>
                  </a>
                ) :
                (
                  <a
                    className="cgu_link"
                    href={opt_ins ? opt_ins["touFilePath"] : null}
                    target="_blank"
                    rel="noopener noreferrer">
                    <p>{t("terms_and_conditions")}</p>
                  </a>
                )}
            {path.includes('/wall') && opt_ins["ucptFilePath"] ?
              (
                <a
                  className="cgu_link"
                  href={opt_ins ? opt_ins["ucptFilePath"] : null}
                  target="_blank"
                  rel="noopener noreferrer">
                  <p>{t("user_content_permission_terms")}</p>
                </a>
              ) : path.includes('/shop') && opt_ins["ppFilePath"] ?
                (
                  <a
                    className="cgu_link"
                    href={opt_ins ? opt_ins["ppFilePath"] : null}
                    target="_blank"
                    rel="noopener noreferrer">
                    <p>{t("privacy_policy")}</p>
                  </a>
                ) :
                (
                  <a
                    className="cgu_link"
                    href={opt_ins ? opt_ins["ppFilePath"] : null}
                    target="_blank"
                    rel="noopener noreferrer">
                    <p>{t("privacy_policy")}</p>
                  </a>
                )}

            {/*  Cookie link active without file path  */}
            {opt_ins["cookieLinkActive"] && !isEmpty(opt_ins["cookieFilePath"]) && (
              <a 
                className="cgu_link"
                href={opt_ins["cookieFilePath"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>{t("cookie_settings")}</p>
              </a>
            )}

            {/*  Cookie link active with file path  */}
            {opt_ins["cookieLinkActive"] && isEmpty(opt_ins["cookieFilePath"]) && (
              <a href="javascript:void(0)"
                className="cgu_link"
                onClick={() => window.Optanon.ToggleInfoDisplay()}
                target=""
              >
                <p>{t("cookie_settings")}</p>
              </a>
            )}

            {opt_ins["impressionFilePath"] && (
              <a 
                target="_blank" 
                className="cgu_link"
                href={opt_ins["impressionFilePath"]} 
                rel="noopener noreferrer"
              >
                <p>{t("impression")}</p>
              </a>
            )}
        </div>
      </div >
    )
  }
}

const mapStateToProps = (state) => ({
  navigation: state.navigation,
  account: state.account,
  config: state.config,
})

function isEmpty(v) {
  return (v === undefined || v == null || v.length <= 0);
}

export default withTranslation()(connect(mapStateToProps)(InsCGUBar))
